import { gql } from '@apollo/client';

export const GET_FAILED_TEST_RESULTS_FOR_FFIEC031 = gql`
query getFailedTestResultsForFFIEC031($input: GetFailedTestResultsForFFIEC031Input) {
  getFailedTestResultsForFFIEC031(input: $input) {
    criteria {
      ruleId
      batchId
      isActive
      editChange
      editType
      editNumber
      effectiveStartDate
      effectiveEndDate
      mdrmList
      schedule
      targetItem
      ruleDescription
    }
    testResults{
      rowId
      testDate
      errorData
      errorColumns
      errorMessage
      errorDescription
      testPass
      testFail
      testError
      testRunStatus
    }
    pagination {
      totalCount
    }
  }
}
`;

export const GET_RULE_AUDIT_LOGS_FOR_FFIEC031 = gql`
query getAuditLogsForFFIEC031($input: GetAuditLogsForFFIEC031Input) {
  getAuditLogsForFFIEC031(input: $input) {
    auditLogId
    eventId
    batchId
    ruleId
    commentId
    commentText
    userId
    user {
      firstName
      lastName
      initials
    }
    event {
      eventName
    }
    comment {
      commentText
    }
    createdAt
  }
}
`;

export const GET_COMMENTS_FOR_FFIEC031 = gql`
query getUserCommentsForFFIEC031($input: GetUserCommentForFFIEC031Input) {
  getUserCommentsForFFIEC031(input: $input) {
    commentText
    commentId
    userId
    user{
    firstName
    lastName
    initials
  }
  FFIEC031AuditLog{
    auditLogId
    eventId
    createdAt
    commentId
  }
  }
}
`;

export const GET_BATCH_TESTS_FOR_FFIEC031 = gql`
query getFFIEC031BatchTests($input: GetFFIEC031BatchTestsInput) {
  getFFIEC031BatchTests(input: $input) {
    batchId
    totalRecords
    batchRunStatus
    batchStartTime
    ruleId
    period
    targetItem
    schedule
    mdrm
    isActive
    isRuleApplicable
    ruleDescription
    updatedAt
    fileName
    testError
    testFail
    testPass
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestExecuted
    totalTestFailed
    totalTestInError
  }
}
`;

export const GET_QUARTER_FILTERED_BATCH_TESTS_FOR_FFIEC031 = gql`
query getFFIEC031BatchTestsByQuarter($input: GetFFIEC031BatchTestsByQuarterInput) {
  getFFIEC031BatchTestsByQuarter(input: $input) {
    batchId
    ruleId
    period
    targetItem
    schedule
    mdrm
    isActive
    isRuleApplicable
    ruleDescription
    updatedAt
    totalRecords
    testPass
    testFail
    testError
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    fileName
    totalTestExecuted
    batchRunStatus
    batchStartTime
  }
}`;

export const GET_SUMMARY_QUARTERS_FOR_FFIEC031 = gql`
query getFFIEC031SummaryQuarters($input: TenantIdInput) {
  getFFIEC031SummaryQuarters(input: $input)
}`;

export const GET_DOWNLOADED_RESULT = gql`
query getFFIEC031SummaryDetailsForDownload($input: GetFFIEC031BatchTestsByQuarterInput) {
  getFFIEC031SummaryDetailsForDownload(input: $input) {
    batchId
    ruleId
    period
    targetItem
    schedule
    mdrm
    isActive
    ruleDescription
    totalRecords
    testPass
    testFail
    testError
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    fileName
    totalTestExecuted
    batchRunStatus
    batchStartTime
  }
}`;

export const GET_LATEST_BATCH_FOR_FFIEC031 = gql`
query getCurrentStatusOfLatestBatchForFFIEC031($input: TenantIdInput) {
  getCurrentStatusOfLatestBatchForFFIEC031(input: $input) {
    batchRunStatus
    batchId
    batchEndTime
    batchStartTime
    totalRecords
    fileName
    totalTestCases
  }
}`;
